<template>
  <b-col lg="10">
    <b-form-group class="text-left"
                  label-class="font-weight-bold pt-0"
                  :label="label">
      <b-form-checkbox
          v-for="option in answers"
          v-model="selected"
          :key="option.value"
          :value="option.value"
          :id="`${option.value}`"
          name="flavour-3a"
          @change="selectedValue(option)"
          stacked
      >
        <b-input v-if="option.addName"
                 v-model="addName"
                 @change="selectedValue(option)"
                 :placeholder="option.text"/>
        <span v-else>{{ option.text }}</span>
      </b-form-checkbox>
    </b-form-group>
  </b-col>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'FormMultiSelect',
  props: {
    label: {
      type: String,
      default: ''
    },
    answers: {
      type: Array,
      default: () => {}
    },
    codeQuestion: {
      type: String,
      default: ''
    },
    value: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      selected: [],
      addName: ''
    }
  },
  methods: {
    selectedValue (item) {
      const code = item.codeQuestions
      const result = {codeQuestion: code, value: ''}
      let value = ''
      if (_.isUndefined(this.value[code])) {
        value = item.addName ? item.text : `${item.value}`
      } else {
        if (item.addName) {
          value = this.value[code] === ' ' ? `${item.text}` : ' '
        } else {
          value = this.value[code] === ' ' ? `${item.value}` : ' '
        }
      }
      this.value[code] = value
      result.value = value
      this.$emit('action-output', result)
    }
  },
  beforeMount () {
    _.forEach(this.answers, (item) => {
      if (this.value[item.codeQuestions] &&
        this.value[item.codeQuestions] !== ' ') {
        this.selected.push(item.value)
        if (item.addName) {
          item.text = this.value[item.codeQuestions]
        }
      }
    })
  },
  watch: {
    addName (val) {
      let item = _.last(this.answers)
      item.text = val
      const code = item.codeQuestions
      this.$emit('action-output', {codeQuestion: code, value: val})
    },
    value: {
      deep: true,
      handler (newValue) {
        console.log('handle newValue', newValue)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/FormMultiSelect.vue